// extracted by mini-css-extract-plugin
export default {"indexBody":"IndexPage_indexBody__XYHYl"};